/* tslint:disable */
/* eslint-disable */
/**
 * Dataland Data Sourcing Service API documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../../../../../../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../../../../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../../../../../../base';
// @ts-ignore
import type { AdminDataSourcingPatch } from '../../../../../../org/dataland/datalandfrontend/openApiClient/datasourcingservice/model';
// @ts-ignore
import type { BasicDataDimensions } from '../../../../../../org/dataland/datalandfrontend/openApiClient/datasourcingservice/model';
// @ts-ignore
import type { DataSourcingPriorityByDataDimensions } from '../../../../../../org/dataland/datalandfrontend/openApiClient/datasourcingservice/model';
// @ts-ignore
import type { DataSourcingState } from '../../../../../../org/dataland/datalandfrontend/openApiClient/datasourcingservice/model';
// @ts-ignore
import type { DataSourcingWithoutReferences } from '../../../../../../org/dataland/datalandfrontend/openApiClient/datasourcingservice/model';
// @ts-ignore
import type { ErrorResponse } from '../../../../../../org/dataland/datalandfrontend/openApiClient/datasourcingservice/model';
// @ts-ignore
import type { ReducedDataSourcing } from '../../../../../../org/dataland/datalandfrontend/openApiClient/datasourcingservice/model';
// @ts-ignore
import type { StoredDataSourcing } from '../../../../../../org/dataland/datalandfrontend/openApiClient/datasourcingservice/model';
/**
 * DataSourcingControllerApi - axios parameter creator
 */
export const DataSourcingControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieve a DataSourcing object by its unique identifier.
         * @summary Get DataSourcing by ID
         * @param {string} dataSourcingId The unique identifier of the data sourcing object.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataSourcingById: async (dataSourcingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dataSourcingId' is not null or undefined
            assertParamExists('getDataSourcingById', 'dataSourcingId', dataSourcingId)
            const localVarPath = `/data-sourcing/{dataSourcingId}`
                .replace(`{${"dataSourcingId"}}`, encodeURIComponent(String(dataSourcingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get DataSourcing by company ID of the assigned external service provider (document collector and/or data extractor).
         * @summary Get DataSourcing by company ID of the provider (document collector and/or data extractor)
         * @param {string} providerCompanyId Dataland company ID of the document collector or data extractor.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataSourcingForCompanyId: async (providerCompanyId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerCompanyId' is not null or undefined
            assertParamExists('getDataSourcingForCompanyId', 'providerCompanyId', providerCompanyId)
            const localVarPath = `/data-sourcing/provider/{providerCompanyId}`
                .replace(`{${"providerCompanyId"}}`, encodeURIComponent(String(providerCompanyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the history of a DataSourcing object by its unique identifier.
         * @summary Get full history of a DataSourcing by ID
         * @param {string} dataSourcingId The unique identifier of the data sourcing object.
         * @param {boolean} [stateChangesOnly] If true, only returns revisions where the state changed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataSourcingHistoryById: async (dataSourcingId: string, stateChangesOnly?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dataSourcingId' is not null or undefined
            assertParamExists('getDataSourcingHistoryById', 'dataSourcingId', dataSourcingId)
            const localVarPath = `/data-sourcing/{dataSourcingId}/history`
                .replace(`{${"dataSourcingId"}}`, encodeURIComponent(String(dataSourcingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            if (stateChangesOnly !== undefined) {
                localVarQueryParameter['stateChangesOnly'] = stateChangesOnly;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * For each provided set of data dimensions with a matching data sourcing object, returns the data dimensions paired with their priority.
         * @summary Get priorities for a list of data dimensions
         * @param {Array<BasicDataDimensions>} basicDataDimensions 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataSourcingPriorities: async (basicDataDimensions: Array<BasicDataDimensions>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'basicDataDimensions' is not null or undefined
            assertParamExists('getDataSourcingPriorities', 'basicDataDimensions', basicDataDimensions)
            const localVarPath = `/data-sourcing/priorities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(basicDataDimensions, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Patch fields of a DataSourcing object specified by ID. Null values are ignored.
         * @summary Patch DataSourcing
         * @param {string} dataSourcingId The unique identifier of the data sourcing object.
         * @param {AdminDataSourcingPatch} adminDataSourcingPatch 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchDataSourcing: async (dataSourcingId: string, adminDataSourcingPatch: AdminDataSourcingPatch, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dataSourcingId' is not null or undefined
            assertParamExists('patchDataSourcing', 'dataSourcingId', dataSourcingId)
            // verify required parameter 'adminDataSourcingPatch' is not null or undefined
            assertParamExists('patchDataSourcing', 'adminDataSourcingPatch', adminDataSourcingPatch)
            const localVarPath = `/data-sourcing/{dataSourcingId}`
                .replace(`{${"dataSourcingId"}}`, encodeURIComponent(String(dataSourcingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminDataSourcingPatch, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Patch the associated document IDs of a DataSourcing object. If appendDocuments is set to true, the provided document IDs are appended to the existing ones. Otherwise, they overwrite the existing ones. If omitted, appendDocuments is treated as true.
         * @summary Patch DataSourcing documents
         * @param {string} dataSourcingId The unique identifier of the data sourcing object.
         * @param {Set<string>} requestBody 
         * @param {boolean} [appendDocuments] Whether to append the provided document IDs to the existing ones. If set to false, the provided document IDs replace the existing ones instead.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchDataSourcingDocuments: async (dataSourcingId: string, requestBody: Set<string>, appendDocuments?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dataSourcingId' is not null or undefined
            assertParamExists('patchDataSourcingDocuments', 'dataSourcingId', dataSourcingId)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('patchDataSourcingDocuments', 'requestBody', requestBody)
            const localVarPath = `/data-sourcing/{dataSourcingId}/documents`
                .replace(`{${"dataSourcingId"}}`, encodeURIComponent(String(dataSourcingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            if (appendDocuments !== undefined) {
                localVarQueryParameter['appendDocuments'] = appendDocuments;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Patch the state of a DataSourcing object specified by ID.
         * @summary Patch DataSourcing state
         * @param {string} dataSourcingId The unique identifier of the data sourcing object.
         * @param {DataSourcingState} state 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchDataSourcingState: async (dataSourcingId: string, state: DataSourcingState, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dataSourcingId' is not null or undefined
            assertParamExists('patchDataSourcingState', 'dataSourcingId', dataSourcingId)
            // verify required parameter 'state' is not null or undefined
            assertParamExists('patchDataSourcingState', 'state', state)
            const localVarPath = `/data-sourcing/{dataSourcingId}/state`
                .replace(`{${"dataSourcingId"}}`, encodeURIComponent(String(dataSourcingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Patch the date of the next planned document sourcing attempt of a DataSourcing object for a given ID.
         * @summary Patch the date of the next planned document sourcing attempt
         * @param {string} dataSourcingId The unique identifier of the data sourcing object.
         * @param {string} dateOfNextDocumentSourcingAttempt The date of the next planned attempt to source documents for this data sourcing object.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchDateOfNextDocumentSourcingAttempt: async (dataSourcingId: string, dateOfNextDocumentSourcingAttempt: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dataSourcingId' is not null or undefined
            assertParamExists('patchDateOfNextDocumentSourcingAttempt', 'dataSourcingId', dataSourcingId)
            // verify required parameter 'dateOfNextDocumentSourcingAttempt' is not null or undefined
            assertParamExists('patchDateOfNextDocumentSourcingAttempt', 'dateOfNextDocumentSourcingAttempt', dateOfNextDocumentSourcingAttempt)
            const localVarPath = `/data-sourcing/{dataSourcingId}/document-sourcing-attempt`
                .replace(`{${"dataSourcingId"}}`, encodeURIComponent(String(dataSourcingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            if (dateOfNextDocumentSourcingAttempt !== undefined) {
                localVarQueryParameter['dateOfNextDocumentSourcingAttempt'] = (dateOfNextDocumentSourcingAttempt as any instanceof Date) ?
                    (dateOfNextDocumentSourcingAttempt as any).toISOString().substring(0,10) :
                    dateOfNextDocumentSourcingAttempt;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search for data sourcing objects using various filter parameters.
         * @summary Search data sourcings.
         * @param {string} [companyId] The unique identifier under which a company can be found on Dataland.
         * @param {string} [dataType] The associated reporting framework or data point type (as applicable).
         * @param {string} [reportingPeriod] The relevant reporting period (e.g. a fiscal year).
         * @param {DataSourcingState} [state] The current state of the data sourcing object.
         * @param {number} [chunkSize] Only a chunk of all matching, ordered results is returned. This parameter specifies the maximum size of a single chunk. All chunks except possibly the last will have that size.
         * @param {number} [chunkIndex] Only a chunk of all matching, ordered results is returned. This parameter specifies which chunk to return, starting at 0. The default value is 0, meaning the first chunk is returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchDataSourcings: async (companyId?: string, dataType?: string, reportingPeriod?: string, state?: DataSourcingState, chunkSize?: number, chunkIndex?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/data-sourcing`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (dataType !== undefined) {
                localVarQueryParameter['dataType'] = dataType;
            }

            if (reportingPeriod !== undefined) {
                localVarQueryParameter['reportingPeriod'] = reportingPeriod;
            }

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }

            if (chunkSize !== undefined) {
                localVarQueryParameter['chunkSize'] = chunkSize;
            }

            if (chunkIndex !== undefined) {
                localVarQueryParameter['chunkIndex'] = chunkIndex;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DataSourcingControllerApi - functional programming interface
 */
export const DataSourcingControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DataSourcingControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieve a DataSourcing object by its unique identifier.
         * @summary Get DataSourcing by ID
         * @param {string} dataSourcingId The unique identifier of the data sourcing object.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDataSourcingById(dataSourcingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StoredDataSourcing>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDataSourcingById(dataSourcingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataSourcingControllerApi.getDataSourcingById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get DataSourcing by company ID of the assigned external service provider (document collector and/or data extractor).
         * @summary Get DataSourcing by company ID of the provider (document collector and/or data extractor)
         * @param {string} providerCompanyId Dataland company ID of the document collector or data extractor.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDataSourcingForCompanyId(providerCompanyId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StoredDataSourcing>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDataSourcingForCompanyId(providerCompanyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataSourcingControllerApi.getDataSourcingForCompanyId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve the history of a DataSourcing object by its unique identifier.
         * @summary Get full history of a DataSourcing by ID
         * @param {string} dataSourcingId The unique identifier of the data sourcing object.
         * @param {boolean} [stateChangesOnly] If true, only returns revisions where the state changed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDataSourcingHistoryById(dataSourcingId: string, stateChangesOnly?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DataSourcingWithoutReferences>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDataSourcingHistoryById(dataSourcingId, stateChangesOnly, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataSourcingControllerApi.getDataSourcingHistoryById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * For each provided set of data dimensions with a matching data sourcing object, returns the data dimensions paired with their priority.
         * @summary Get priorities for a list of data dimensions
         * @param {Array<BasicDataDimensions>} basicDataDimensions 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDataSourcingPriorities(basicDataDimensions: Array<BasicDataDimensions>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DataSourcingPriorityByDataDimensions>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDataSourcingPriorities(basicDataDimensions, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataSourcingControllerApi.getDataSourcingPriorities']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Patch fields of a DataSourcing object specified by ID. Null values are ignored.
         * @summary Patch DataSourcing
         * @param {string} dataSourcingId The unique identifier of the data sourcing object.
         * @param {AdminDataSourcingPatch} adminDataSourcingPatch 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchDataSourcing(dataSourcingId: string, adminDataSourcingPatch: AdminDataSourcingPatch, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StoredDataSourcing>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchDataSourcing(dataSourcingId, adminDataSourcingPatch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataSourcingControllerApi.patchDataSourcing']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Patch the associated document IDs of a DataSourcing object. If appendDocuments is set to true, the provided document IDs are appended to the existing ones. Otherwise, they overwrite the existing ones. If omitted, appendDocuments is treated as true.
         * @summary Patch DataSourcing documents
         * @param {string} dataSourcingId The unique identifier of the data sourcing object.
         * @param {Set<string>} requestBody 
         * @param {boolean} [appendDocuments] Whether to append the provided document IDs to the existing ones. If set to false, the provided document IDs replace the existing ones instead.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchDataSourcingDocuments(dataSourcingId: string, requestBody: Set<string>, appendDocuments?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReducedDataSourcing>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchDataSourcingDocuments(dataSourcingId, requestBody, appendDocuments, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataSourcingControllerApi.patchDataSourcingDocuments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Patch the state of a DataSourcing object specified by ID.
         * @summary Patch DataSourcing state
         * @param {string} dataSourcingId The unique identifier of the data sourcing object.
         * @param {DataSourcingState} state 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchDataSourcingState(dataSourcingId: string, state: DataSourcingState, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReducedDataSourcing>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchDataSourcingState(dataSourcingId, state, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataSourcingControllerApi.patchDataSourcingState']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Patch the date of the next planned document sourcing attempt of a DataSourcing object for a given ID.
         * @summary Patch the date of the next planned document sourcing attempt
         * @param {string} dataSourcingId The unique identifier of the data sourcing object.
         * @param {string} dateOfNextDocumentSourcingAttempt The date of the next planned attempt to source documents for this data sourcing object.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchDateOfNextDocumentSourcingAttempt(dataSourcingId: string, dateOfNextDocumentSourcingAttempt: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReducedDataSourcing>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchDateOfNextDocumentSourcingAttempt(dataSourcingId, dateOfNextDocumentSourcingAttempt, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataSourcingControllerApi.patchDateOfNextDocumentSourcingAttempt']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search for data sourcing objects using various filter parameters.
         * @summary Search data sourcings.
         * @param {string} [companyId] The unique identifier under which a company can be found on Dataland.
         * @param {string} [dataType] The associated reporting framework or data point type (as applicable).
         * @param {string} [reportingPeriod] The relevant reporting period (e.g. a fiscal year).
         * @param {DataSourcingState} [state] The current state of the data sourcing object.
         * @param {number} [chunkSize] Only a chunk of all matching, ordered results is returned. This parameter specifies the maximum size of a single chunk. All chunks except possibly the last will have that size.
         * @param {number} [chunkIndex] Only a chunk of all matching, ordered results is returned. This parameter specifies which chunk to return, starting at 0. The default value is 0, meaning the first chunk is returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchDataSourcings(companyId?: string, dataType?: string, reportingPeriod?: string, state?: DataSourcingState, chunkSize?: number, chunkIndex?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StoredDataSourcing>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchDataSourcings(companyId, dataType, reportingPeriod, state, chunkSize, chunkIndex, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataSourcingControllerApi.searchDataSourcings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DataSourcingControllerApi - factory interface
 */
export const DataSourcingControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DataSourcingControllerApiFp(configuration)
    return {
        /**
         * Retrieve a DataSourcing object by its unique identifier.
         * @summary Get DataSourcing by ID
         * @param {string} dataSourcingId The unique identifier of the data sourcing object.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataSourcingById(dataSourcingId: string, options?: RawAxiosRequestConfig): AxiosPromise<StoredDataSourcing> {
            return localVarFp.getDataSourcingById(dataSourcingId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get DataSourcing by company ID of the assigned external service provider (document collector and/or data extractor).
         * @summary Get DataSourcing by company ID of the provider (document collector and/or data extractor)
         * @param {string} providerCompanyId Dataland company ID of the document collector or data extractor.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataSourcingForCompanyId(providerCompanyId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<StoredDataSourcing>> {
            return localVarFp.getDataSourcingForCompanyId(providerCompanyId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the history of a DataSourcing object by its unique identifier.
         * @summary Get full history of a DataSourcing by ID
         * @param {string} dataSourcingId The unique identifier of the data sourcing object.
         * @param {boolean} [stateChangesOnly] If true, only returns revisions where the state changed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataSourcingHistoryById(dataSourcingId: string, stateChangesOnly?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Array<DataSourcingWithoutReferences>> {
            return localVarFp.getDataSourcingHistoryById(dataSourcingId, stateChangesOnly, options).then((request) => request(axios, basePath));
        },
        /**
         * For each provided set of data dimensions with a matching data sourcing object, returns the data dimensions paired with their priority.
         * @summary Get priorities for a list of data dimensions
         * @param {Array<BasicDataDimensions>} basicDataDimensions 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataSourcingPriorities(basicDataDimensions: Array<BasicDataDimensions>, options?: RawAxiosRequestConfig): AxiosPromise<Array<DataSourcingPriorityByDataDimensions>> {
            return localVarFp.getDataSourcingPriorities(basicDataDimensions, options).then((request) => request(axios, basePath));
        },
        /**
         * Patch fields of a DataSourcing object specified by ID. Null values are ignored.
         * @summary Patch DataSourcing
         * @param {string} dataSourcingId The unique identifier of the data sourcing object.
         * @param {AdminDataSourcingPatch} adminDataSourcingPatch 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchDataSourcing(dataSourcingId: string, adminDataSourcingPatch: AdminDataSourcingPatch, options?: RawAxiosRequestConfig): AxiosPromise<StoredDataSourcing> {
            return localVarFp.patchDataSourcing(dataSourcingId, adminDataSourcingPatch, options).then((request) => request(axios, basePath));
        },
        /**
         * Patch the associated document IDs of a DataSourcing object. If appendDocuments is set to true, the provided document IDs are appended to the existing ones. Otherwise, they overwrite the existing ones. If omitted, appendDocuments is treated as true.
         * @summary Patch DataSourcing documents
         * @param {string} dataSourcingId The unique identifier of the data sourcing object.
         * @param {Set<string>} requestBody 
         * @param {boolean} [appendDocuments] Whether to append the provided document IDs to the existing ones. If set to false, the provided document IDs replace the existing ones instead.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchDataSourcingDocuments(dataSourcingId: string, requestBody: Set<string>, appendDocuments?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<ReducedDataSourcing> {
            return localVarFp.patchDataSourcingDocuments(dataSourcingId, requestBody, appendDocuments, options).then((request) => request(axios, basePath));
        },
        /**
         * Patch the state of a DataSourcing object specified by ID.
         * @summary Patch DataSourcing state
         * @param {string} dataSourcingId The unique identifier of the data sourcing object.
         * @param {DataSourcingState} state 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchDataSourcingState(dataSourcingId: string, state: DataSourcingState, options?: RawAxiosRequestConfig): AxiosPromise<ReducedDataSourcing> {
            return localVarFp.patchDataSourcingState(dataSourcingId, state, options).then((request) => request(axios, basePath));
        },
        /**
         * Patch the date of the next planned document sourcing attempt of a DataSourcing object for a given ID.
         * @summary Patch the date of the next planned document sourcing attempt
         * @param {string} dataSourcingId The unique identifier of the data sourcing object.
         * @param {string} dateOfNextDocumentSourcingAttempt The date of the next planned attempt to source documents for this data sourcing object.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchDateOfNextDocumentSourcingAttempt(dataSourcingId: string, dateOfNextDocumentSourcingAttempt: string, options?: RawAxiosRequestConfig): AxiosPromise<ReducedDataSourcing> {
            return localVarFp.patchDateOfNextDocumentSourcingAttempt(dataSourcingId, dateOfNextDocumentSourcingAttempt, options).then((request) => request(axios, basePath));
        },
        /**
         * Search for data sourcing objects using various filter parameters.
         * @summary Search data sourcings.
         * @param {string} [companyId] The unique identifier under which a company can be found on Dataland.
         * @param {string} [dataType] The associated reporting framework or data point type (as applicable).
         * @param {string} [reportingPeriod] The relevant reporting period (e.g. a fiscal year).
         * @param {DataSourcingState} [state] The current state of the data sourcing object.
         * @param {number} [chunkSize] Only a chunk of all matching, ordered results is returned. This parameter specifies the maximum size of a single chunk. All chunks except possibly the last will have that size.
         * @param {number} [chunkIndex] Only a chunk of all matching, ordered results is returned. This parameter specifies which chunk to return, starting at 0. The default value is 0, meaning the first chunk is returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchDataSourcings(companyId?: string, dataType?: string, reportingPeriod?: string, state?: DataSourcingState, chunkSize?: number, chunkIndex?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<StoredDataSourcing>> {
            return localVarFp.searchDataSourcings(companyId, dataType, reportingPeriod, state, chunkSize, chunkIndex, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DataSourcingControllerApi - interface
 */
export interface DataSourcingControllerApiInterface {
    /**
     * Retrieve a DataSourcing object by its unique identifier.
     * @summary Get DataSourcing by ID
     * @param {string} dataSourcingId The unique identifier of the data sourcing object.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDataSourcingById(dataSourcingId: string, options?: RawAxiosRequestConfig): AxiosPromise<StoredDataSourcing>;

    /**
     * Get DataSourcing by company ID of the assigned external service provider (document collector and/or data extractor).
     * @summary Get DataSourcing by company ID of the provider (document collector and/or data extractor)
     * @param {string} providerCompanyId Dataland company ID of the document collector or data extractor.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDataSourcingForCompanyId(providerCompanyId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<StoredDataSourcing>>;

    /**
     * Retrieve the history of a DataSourcing object by its unique identifier.
     * @summary Get full history of a DataSourcing by ID
     * @param {string} dataSourcingId The unique identifier of the data sourcing object.
     * @param {boolean} [stateChangesOnly] If true, only returns revisions where the state changed.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDataSourcingHistoryById(dataSourcingId: string, stateChangesOnly?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Array<DataSourcingWithoutReferences>>;

    /**
     * For each provided set of data dimensions with a matching data sourcing object, returns the data dimensions paired with their priority.
     * @summary Get priorities for a list of data dimensions
     * @param {Array<BasicDataDimensions>} basicDataDimensions 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDataSourcingPriorities(basicDataDimensions: Array<BasicDataDimensions>, options?: RawAxiosRequestConfig): AxiosPromise<Array<DataSourcingPriorityByDataDimensions>>;

    /**
     * Patch fields of a DataSourcing object specified by ID. Null values are ignored.
     * @summary Patch DataSourcing
     * @param {string} dataSourcingId The unique identifier of the data sourcing object.
     * @param {AdminDataSourcingPatch} adminDataSourcingPatch 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchDataSourcing(dataSourcingId: string, adminDataSourcingPatch: AdminDataSourcingPatch, options?: RawAxiosRequestConfig): AxiosPromise<StoredDataSourcing>;

    /**
     * Patch the associated document IDs of a DataSourcing object. If appendDocuments is set to true, the provided document IDs are appended to the existing ones. Otherwise, they overwrite the existing ones. If omitted, appendDocuments is treated as true.
     * @summary Patch DataSourcing documents
     * @param {string} dataSourcingId The unique identifier of the data sourcing object.
     * @param {Set<string>} requestBody 
     * @param {boolean} [appendDocuments] Whether to append the provided document IDs to the existing ones. If set to false, the provided document IDs replace the existing ones instead.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchDataSourcingDocuments(dataSourcingId: string, requestBody: Set<string>, appendDocuments?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<ReducedDataSourcing>;

    /**
     * Patch the state of a DataSourcing object specified by ID.
     * @summary Patch DataSourcing state
     * @param {string} dataSourcingId The unique identifier of the data sourcing object.
     * @param {DataSourcingState} state 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchDataSourcingState(dataSourcingId: string, state: DataSourcingState, options?: RawAxiosRequestConfig): AxiosPromise<ReducedDataSourcing>;

    /**
     * Patch the date of the next planned document sourcing attempt of a DataSourcing object for a given ID.
     * @summary Patch the date of the next planned document sourcing attempt
     * @param {string} dataSourcingId The unique identifier of the data sourcing object.
     * @param {string} dateOfNextDocumentSourcingAttempt The date of the next planned attempt to source documents for this data sourcing object.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchDateOfNextDocumentSourcingAttempt(dataSourcingId: string, dateOfNextDocumentSourcingAttempt: string, options?: RawAxiosRequestConfig): AxiosPromise<ReducedDataSourcing>;

    /**
     * Search for data sourcing objects using various filter parameters.
     * @summary Search data sourcings.
     * @param {string} [companyId] The unique identifier under which a company can be found on Dataland.
     * @param {string} [dataType] The associated reporting framework or data point type (as applicable).
     * @param {string} [reportingPeriod] The relevant reporting period (e.g. a fiscal year).
     * @param {DataSourcingState} [state] The current state of the data sourcing object.
     * @param {number} [chunkSize] Only a chunk of all matching, ordered results is returned. This parameter specifies the maximum size of a single chunk. All chunks except possibly the last will have that size.
     * @param {number} [chunkIndex] Only a chunk of all matching, ordered results is returned. This parameter specifies which chunk to return, starting at 0. The default value is 0, meaning the first chunk is returned.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchDataSourcings(companyId?: string, dataType?: string, reportingPeriod?: string, state?: DataSourcingState, chunkSize?: number, chunkIndex?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<StoredDataSourcing>>;

}

/**
 * DataSourcingControllerApi - object-oriented interface
 */
export class DataSourcingControllerApi extends BaseAPI implements DataSourcingControllerApiInterface {
    /**
     * Retrieve a DataSourcing object by its unique identifier.
     * @summary Get DataSourcing by ID
     * @param {string} dataSourcingId The unique identifier of the data sourcing object.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getDataSourcingById(dataSourcingId: string, options?: RawAxiosRequestConfig) {
        return DataSourcingControllerApiFp(this.configuration).getDataSourcingById(dataSourcingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get DataSourcing by company ID of the assigned external service provider (document collector and/or data extractor).
     * @summary Get DataSourcing by company ID of the provider (document collector and/or data extractor)
     * @param {string} providerCompanyId Dataland company ID of the document collector or data extractor.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getDataSourcingForCompanyId(providerCompanyId: string, options?: RawAxiosRequestConfig) {
        return DataSourcingControllerApiFp(this.configuration).getDataSourcingForCompanyId(providerCompanyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve the history of a DataSourcing object by its unique identifier.
     * @summary Get full history of a DataSourcing by ID
     * @param {string} dataSourcingId The unique identifier of the data sourcing object.
     * @param {boolean} [stateChangesOnly] If true, only returns revisions where the state changed.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getDataSourcingHistoryById(dataSourcingId: string, stateChangesOnly?: boolean, options?: RawAxiosRequestConfig) {
        return DataSourcingControllerApiFp(this.configuration).getDataSourcingHistoryById(dataSourcingId, stateChangesOnly, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * For each provided set of data dimensions with a matching data sourcing object, returns the data dimensions paired with their priority.
     * @summary Get priorities for a list of data dimensions
     * @param {Array<BasicDataDimensions>} basicDataDimensions 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getDataSourcingPriorities(basicDataDimensions: Array<BasicDataDimensions>, options?: RawAxiosRequestConfig) {
        return DataSourcingControllerApiFp(this.configuration).getDataSourcingPriorities(basicDataDimensions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Patch fields of a DataSourcing object specified by ID. Null values are ignored.
     * @summary Patch DataSourcing
     * @param {string} dataSourcingId The unique identifier of the data sourcing object.
     * @param {AdminDataSourcingPatch} adminDataSourcingPatch 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public patchDataSourcing(dataSourcingId: string, adminDataSourcingPatch: AdminDataSourcingPatch, options?: RawAxiosRequestConfig) {
        return DataSourcingControllerApiFp(this.configuration).patchDataSourcing(dataSourcingId, adminDataSourcingPatch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Patch the associated document IDs of a DataSourcing object. If appendDocuments is set to true, the provided document IDs are appended to the existing ones. Otherwise, they overwrite the existing ones. If omitted, appendDocuments is treated as true.
     * @summary Patch DataSourcing documents
     * @param {string} dataSourcingId The unique identifier of the data sourcing object.
     * @param {Set<string>} requestBody 
     * @param {boolean} [appendDocuments] Whether to append the provided document IDs to the existing ones. If set to false, the provided document IDs replace the existing ones instead.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public patchDataSourcingDocuments(dataSourcingId: string, requestBody: Set<string>, appendDocuments?: boolean, options?: RawAxiosRequestConfig) {
        return DataSourcingControllerApiFp(this.configuration).patchDataSourcingDocuments(dataSourcingId, requestBody, appendDocuments, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Patch the state of a DataSourcing object specified by ID.
     * @summary Patch DataSourcing state
     * @param {string} dataSourcingId The unique identifier of the data sourcing object.
     * @param {DataSourcingState} state 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public patchDataSourcingState(dataSourcingId: string, state: DataSourcingState, options?: RawAxiosRequestConfig) {
        return DataSourcingControllerApiFp(this.configuration).patchDataSourcingState(dataSourcingId, state, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Patch the date of the next planned document sourcing attempt of a DataSourcing object for a given ID.
     * @summary Patch the date of the next planned document sourcing attempt
     * @param {string} dataSourcingId The unique identifier of the data sourcing object.
     * @param {string} dateOfNextDocumentSourcingAttempt The date of the next planned attempt to source documents for this data sourcing object.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public patchDateOfNextDocumentSourcingAttempt(dataSourcingId: string, dateOfNextDocumentSourcingAttempt: string, options?: RawAxiosRequestConfig) {
        return DataSourcingControllerApiFp(this.configuration).patchDateOfNextDocumentSourcingAttempt(dataSourcingId, dateOfNextDocumentSourcingAttempt, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search for data sourcing objects using various filter parameters.
     * @summary Search data sourcings.
     * @param {string} [companyId] The unique identifier under which a company can be found on Dataland.
     * @param {string} [dataType] The associated reporting framework or data point type (as applicable).
     * @param {string} [reportingPeriod] The relevant reporting period (e.g. a fiscal year).
     * @param {DataSourcingState} [state] The current state of the data sourcing object.
     * @param {number} [chunkSize] Only a chunk of all matching, ordered results is returned. This parameter specifies the maximum size of a single chunk. All chunks except possibly the last will have that size.
     * @param {number} [chunkIndex] Only a chunk of all matching, ordered results is returned. This parameter specifies which chunk to return, starting at 0. The default value is 0, meaning the first chunk is returned.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchDataSourcings(companyId?: string, dataType?: string, reportingPeriod?: string, state?: DataSourcingState, chunkSize?: number, chunkIndex?: number, options?: RawAxiosRequestConfig) {
        return DataSourcingControllerApiFp(this.configuration).searchDataSourcings(companyId, dataType, reportingPeriod, state, chunkSize, chunkIndex, options).then((request) => request(this.axios, this.basePath));
    }
}

